export default "__VITE_ASSET__B4q8g7zQ__"